import Vuex from 'vuex'
import Vue from 'vue'
import Firebase from "firebase"
import config from './config/firebase.config'

import user from './store/modules/user'
import contas from './store/modules/contas'
import transacao from './store/modules/transacao'
import associacao from './store/modules/associacao'
import associados from './store/modules/associados'
import estatisticasFinanceiras from './store/modules/estatisticasFinanceiras'

Firebase.initializeApp(config)
// Firebase.firestore().settings({timestampsInSnapshots: true})

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        user,
        contas,
        transacao,
        associacao,
        associados,
        estatisticasFinanceiras
    },
    //strict: debug
})